import { render, staticRenderFns } from "./frontendRoleModal.vue?vue&type=template&id=607d2786&scoped=true&"
import script from "./frontendRoleModal.vue?vue&type=script&lang=js&"
export * from "./frontendRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./frontendRoleModal.vue?vue&type=style&index=0&id=607d2786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d2786",
  null
  
)

export default component.exports